import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungSiegen() {
  return (
    <CityPageTemplate
      city="Siegen"
      slug="siegen"
      intro="Siegen als Universitätsstadt im Süderland – smarte Finanzplanung für eine zukunftssichere Region."
      description="Unabhängige & digitale Finanzberatung für Siegen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
